import React from 'react';
import styles from '../../styles/main.scss';

const Footer = () => {
  return <footer className={styles.footer}>©{new Date().getFullYear()} Studio Nopposan.</footer>;
};

export default Footer;